export default {
  app: {
    tradeOffers: {
      country: 'Country',
      loginPrompt: 'To see private trade offers, you need to {0}.',
      logIn: 'log in',
      info: 'Information',
      address: 'Address',
      email: 'E-mail',
      social: 'Social media',
      phone: 'Phone',
      web: 'Web',
    },
  },
};
